export function logIn(redirect?: string) {
    import('./session')
        .then(({ lazyLogIn }) => {
            lazyLogIn(redirect);
        })
        .catch(err => {
            console.error(err);
        });
}

export function logOut() {
    import('./session')
        .then(({ lazyLogOut }) => {
            lazyLogOut();
        })
        .catch(err => {
            console.error(err);
        });
}